import { Link, Box, Text as ChakraText } from '@chakra-ui/layout'
import { Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import numeral from 'numeral'
import type { AnalyticsAPIResponse } from '../../interfaces'
import ScrollableTable from './ScrollableTable'

interface Props {
  data: AnalyticsAPIResponse
}

const Top404Table = ({ data }: Props): React.ReactElement => {
  const { t } = useTranslation()

  const top404Data = data.top404?.t404

  if (!top404Data || !Object.keys(top404Data).length) {
    return (
      <Box marginTop="1rem">{t('no_data_available', 'No Data Available')}</Box>
    )
  }

  const tableRows = top404Data.map(item => {
    if (!item.url || item.url.trim() === '-') {
      return null
    }
    return (
      <Tr key={item.url}>
        <Td width="50em">{item.url}</Td>
        <Td>{numeral(item.views).format('0.0 a').toUpperCase()}</Td>
      </Tr>
    )
  })

  return (
    <Box marginTop="1rem">
      <Trans t={t} i18nKey="top_404_table_error_message">
        <ChakraText color="gray.500">
          When ImageKit.io is unable to access the image from your{' '}
          <Link href="https://docs.imagekit.io/integration/configure-origin">
            origin
          </Link>
          , it returns a 404 response. Please check your origin settings in the
          ImageKit.io dashboard and troubleshoot logs at your web server origin.
          In the case of S3 bucket origin, please ensure that the origin setting
          has the correct access and secret key.
        </ChakraText>
      </Trans>

      <Box marginTop="2.5rem">
        <ScrollableTable>
          <Thead>
            <Tr>
              <Th width="50em">{t('url', 'URL')}</Th>
              <Th>{t('count', 'Count')}</Th>
            </Tr>
          </Thead>
          <Tbody>{tableRows}</Tbody>
        </ScrollableTable>
      </Box>
    </Box>
  )
}

export default Top404Table
